<template>
	<!-- ------------------------------------- 顶部导航栏 ----------------------------------- -->
	<div class="header" id="nav" :class="{ 'fix-nav': navBarFixed }">
		<!-- --------------- LOGO --------------- -->
		<img class="icon_logo" @click="toIndex()" src="../assets/images/icon/logo1.png" alt="" />
		<!-- --------------- web导航部分 ---------------  -->
		<div class="web_style">
			<!-- 导航操作 -->
			<div class="nav_operate">
				<!-- 搜索栏 -->
				<div class="search">
					<input type="text" v-model="searchData" placeholder="搜索" />
					<!-- 图标-放大镜 -->
					<img style="cursor: pointer" @click="toSearch()" src="../assets/images/icon/search.png" alt="" />
				</div>

				<!-- 博客 -->
				<div class="blog" @click="toBlog()">博客</div>
				<div class="website" @click="toRecord()">
					<div class="box1">
						<div class="webBox">
							<img src="../assets/images/Aadd.png" alt="" style="" />
						</div>
						<div class="webText">其他品牌滤网</div>
						<div class="webBox1">
							<img src="../assets/jiantou.gif" alt="" />
						</div>
					</div>
				</div>
				<!-- <div class="blog" @click="open3()">博客</div> -->
				<!-- 国际化 -->
				<div class="international">
					<!-- <p :class="langIndex === 1 ? 'selectLang' : ''" @click="langIndex = 1;$i18n.locale = 'zh'">简</p> -->
					<!-- <p :class="langIndex === 2 ? 'selectLang' : ''" @click="langIndex = 2;$i18n.locale = 'tw'">繁</p> -->
					<!-- <p :class="langIndex === 3 ? 'selectLang' : ''" @click="langIndex = 3;$i18n.locale = 'en'">EN</p> -->
					<p :class="langIndex === 1 ? 'selectLang' : ''" @click="toCn">简</p>
					<p :class="langIndex === 3 ? 'selectLang' : ''" @click="toEn">EN</p>
				</div>
				<!-- 购物车 -->
				<!-- <img @click="open3" class="shopping" src="../assets/images/icon/shopping.png" alt=""> -->
			</div>
			<!-- 导航标签 -->
			<div class="nav_label">
				<el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal">
					<el-menu-item v-for="(item, index) in titleList" :index="item.url" :key="item.id"
						active-text-color="#6C6969" @click="toUrl(item, index)">
						{{ item.title }}
					</el-menu-item>
				</el-menu>
			</div>
		</div>
		<!-- --------------- mobile导航部分 --------------- -->
		<div class="mobile_style">
			<!-- 弹窗按钮 -->
			<img @click="showDrawer()" src="../assets/images/icon/menu.png" alt="" />
			<!-- 弹窗内容 -->
			<a-drawer :placement="placement" :closable="false" :visible="visible"
				:wrapStyle="{ marginTop: headHeight + 'px' }" width="100%" @close="onClose" :drawerStyle="{
          paddingTop: '40px',
        }">
				<!-- 导航 -->
				<div class="mobile_navbar">
					<!-- 主页 -->
					<router-link to="/">
						<div class="nav_box"><span>主页</span></div>
					</router-link>
					<!-- 关于我们 -->
					<router-link to="/about">
						<div class="nav_box"><span>关于我们</span></div>
					</router-link>
					<!-- AIR -->
					<div class="select_box">
						<router-link to="/air"><span>AIR</span></router-link>
						<i class="el-icon-arrow-down el-icon--right" @click="mainCheck1()"></i>
					</div>
					<div class="air_main" v-if="this.mainState1 == true">
						<router-link :to="{ name: 'air', params: { tabId: 0 } }">
							<div class="main">RA488高效空气净化器</div>
						</router-link>
						<router-link :to="{ name: 'air', params: { tabId: 1 } }">
							<div class="main">RA800高效空气净化器</div>
						</router-link>
						<!-- <router-link :to="{ name: 'air', params: { tabId: 2 } }">
							<div class="main">PN-02B/W纳米等离子空气净化器</div>
						</router-link> -->
					</div>
					<!-- GREEN -->
					<!-- <router-link to="/green">
                        <div class="nav_box"><span>GREEN</span></div>
                    </router-link> -->
					<!-- CARE -->
					<div class="select_box">
						<router-link to="/care"><span>CARE</span></router-link>
						<i class="el-icon-arrow-down el-icon--right" @click="mainCheck2()"></i>
					</div>
					<div class="air_main" v-if="this.mainState2 == true">
						<router-link :to="{ name: 'care', params: { cur: 0 } }">
							<div class="main">净化机清洁服务</div>
						</router-link>
						<router-link :to="{ name: 'care', params: { cur: 1 } }">
							<div class="main">合约期外保养服务</div>
						</router-link>
						<!-- <router-link :to="{ name: 'care', params: { cur: 0 }}">
                            <div class="main">专项空气检测服务</div>
                        </router-link> -->
					</div>
					<!-- 2D体验馆 -->
					<router-link to="/experience">
						<div class="nav_box"><span>2D体验馆</span></div>
					</router-link>
					<!-- 预约空气检测 -->
					<router-link to="/airtest">
						<div class="nav_box"><span>预约空气检测</span></div>
					</router-link>
					<!-- 企业资讯 -->
					<router-link to="/news">
						<div class="nav_box"><span>企业资讯</span></div>
					</router-link>
					<!-- 加盟我们 -->
					<router-link to="/join">
						<div class="nav_box"><span>加入我们</span></div>
					</router-link>
					<!-- 订阅我们 -->
					<router-link to="/subscribe">
						<div class="nav_box"><span>订阅我们</span></div>
					</router-link>
					<!-- 博客 -->
					<router-link to="/blog">
						<div class="nav_box"><span>博客</span></div>
					</router-link>
				</div>
				<!-- 国际化 -->
				<div class="internat">
					<div class="international">
						<!-- <p :class="langIndex === 1 ? 'selectLang' : ''" @click="langIndex = 1;$i18n.locale = 'zh'">简</p> -->
						<!-- <p :class="langIndex === 2 ? 'selectLang' : ''" @click="langIndex = 2;$i18n.locale = 'tw'">繁</p> -->
						<!-- <p :class="langIndex === 3 ? 'selectLang' : ''" @click="langIndex = 3;$i18n.locale = 'en'">EN</p> -->
						<p :class="langIndex === 1 ? 'selectLang' : ''" @click="toCn">简</p>
						<p :class="langIndex === 3 ? 'selectLang' : ''" @click="toEn">EN</p>
					</div>
					<!-- 购物车 -->
					<!-- <img @click="open3" class="shopping" src="../assets/images/icon/shopping.png" alt=""> -->
				</div>

				<!-- 关注我们、支付方式 -->
				<div class="focus">
					<!-- 关注我们 -->
					<div class="focus_box">
						<div class="title">关注我们</div>
						<div class="icon_list">
							<!-- 微信 -->
							<el-popover placement="top-start" trigger="hover">
								<div>
									<img class="wechat_code" src="../assets/images/icon/wechat-code.jpg" alt="" />
								</div>
								<img slot="reference" src="../assets/images/icon/wechat.png" alt="" />
							</el-popover>
							<!-- facebook -->
							<a href="https://www.facebook.com/Renaud-Air-China-2139475802801534/" target="_blank">
								<img src="../assets/images/icon/facebook.png" alt="" />
							</a>
							<!-- Linkedin -->
							<a href="https://www.linkedin.com/company/renaud-air-china/" target="_blank">
								<img src="../assets/images/icon/ins.png" alt="" />
							</a>
							<!-- 淘宝 -->
							<a href="https://www.shop306540905.taobao.com" target="_blank">
								<img src="../assets/images/icon/taobao.png" alt="" />
							</a>
							<!-- 微博 -->
							<a href="http://www.weibo.com/renaudair" target="_blank">
								<img src="../assets/images/icon/sina.png" alt="" />
							</a>
						</div>
					</div>
					<!-- 支付方式 -->
					<div class="focus_box">
						<div class="title">支付方式</div>
						<div class="icon_list">
							<img src="../assets/images/icon/pocket.png" alt="" />
							<img src="../assets/images/icon/wechat-pay.png" alt="" />
							<img src="../assets/images/icon/alipay.png" alt="" />
							<img class="img_on" src="../assets/images/icon/union.png" alt="" />
						</div>
					</div>
				</div>
			</a-drawer>
		</div>
		<!-- --------------- NEED HELP --------------- -->
		<!-- <img class="help" src="../assets/images//float-help.png" alt=""> -->
	</div>
</template>

<script>
	export default {
		watch: {
			// 国际化
			"$i18n.locale"(newValue) {
				this.titleList.forEach((element, index) => {
					element.title = this.$t("header").titleList[index].title;
				});
			},
		},
		data() {
			return {
				// 下拉内容状态
				mainState1: true,
				mainState2: true,
				searchData: "",
				navBarFixed: false,
				headHeight: 0,
				// 移动端弹窗状态
				visible: false,
				// 移动端弹窗弹出方向
				placement: "right",
				// 顶部导航栏标签
				activeIndex: "1",
				titleList: [{
						id: 1,
						title: "主页",
						url: "/"
					},
					{
						id: 2,
						title: "关于我们",
						url: "/about"
					},
					{
						id: 3,
						title: "AIR",
						url: "/air"
					},
					// { id:4, title: 'GREEN', url: '/green' },
					{
						id: 5,
						title: "CARE",
						url: "/care"
					},
					{
						id: 6,
						title: "2D体验馆",
						url: "/experience"
					},
					{
						id: 7,
						title: "预约空气检测",
						url: "/airtest"
					},
					{
						id: 8,
						title: "企业资讯",
						url: "/news"
					},
					{
						id: 9,
						title: "加入我们",
						url: "/join"
					},
					{
						id: 10,
						title: "订阅我们",
						url: "/subscribe"
					},
				],
				langIndex: 1,
			};
		},
		mounted() {
			// 事件监听滚动条
			window.addEventListener("scroll", this.watchScroll);
		},
		destroyed() {
			// 移除事件监听
			window.removeEventListener("scroll", this.watchScroll);
		},
		watch: {
			openKeys(val) {},
		},
		methods: {
			// 跳转英文
			toEn() {
				this.langIndex = 3;

				let that = this;
				let path = this.$route.path;
				if (path == "/") {
					if (that.langIndex == 3) {
						// window.location.href = "http://192.168.1.147:8082/en/#" + path;
						window.location.href = "http://www.renaudchina.com/en/#" + path;
						//
					}
				} else {
					debugger
					if(window.location.pathname == '/blogDetails'){
						window.location.href =
							"http://www.renaudchina.com/en/#/"+ "pages" + path + window.location.search;
					}else if (window.location.pathname != '/blogDetails') {
						window.location.href =
							"http://www.renaudchina.com/en/#/" + "pages" + path;
					} 
				}
		

			},
			// 跳转中文
			toCn() {
				this.langIndex = 1;
				if (this.langIndex == 1) {
					window.location.href = "http://www.renaudchina.com/#/";
				}
			},
			toRecord() {
				window.open("http://www.medicfilter.com.cn/", "_blank");
			},

			// 下拉图标点击
			mainCheck1() {
				this.mainState1 = !this.mainState1;
			},
			mainCheck2() {
				this.mainState2 = !this.mainState2;
			},
			// 导航栏跳转
			toUrl(item, index) {
				// if (item.title === '2D体验馆'){
				//   this.$message.warning('即将上线，敬请期待！',1);
				//   return
				// }
				this.$router.push({
					path: item.url,
				});
			},
			// 常见问题跳转
			toBlog() {
				this.$router.push({
					path: "/blog",
				});
			},
			// 首页跳转
			toIndex() {
				this.$router.push({
					path: "/",
				});
			},
			// 跳转搜索页面
			toSearch() {
				var that = this;
				this.$router.push({
					path: "/search",
					query: {
						setId: that.searchData
					},
				});
			},
			open3() {
				this.$message.warning("即将上线，敬请期待！", 1);
				//  this.$router.push({
				//     path: '/blog',

				// })
			},
			watchScroll() {
				// 滚动的距离
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				// 容器的高度
				var offsetTop = document.querySelector("#nav").offsetHeight;
				//  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
				if (scrollTop > 0) {
					this.navBarFixed = true;
				} else {
					this.navBarFixed = false;
				}
			},
			// 移动端导航栏
			showDrawer() {
				this.visible = !this.visible;
				this.headHeight = document.querySelector("#nav").offsetHeight;
			},
			onClose() {
				this.visible = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	/* 固定导航 */
	.fix-nav {
		position: fixed;
		top: 0;
		z-index: 999;
	}

	/* ------------------------------ mobile顶部导航栏 ----------------------------- */
	.mobile_style {
		width: 68%;
		height: 50px;
		display: flex;
		align-content: center;
		justify-content: end;

		img {
			width: 110px;
			height: 100px;
			display: block;
			float: right;
			margin-top: -20px;
		}
	}

	// 导航
	.mobile_navbar {
		width: 80%;
		margin: 0 auto;
		border-bottom: 5px solid #00a0e9;
		margin-bottom: 60px;

		.nav_box {
			width: 100%;
			margin-bottom: 70px;

			span {
				font-size: 70px;
				font-weight: bold;
				color: #425073;
				letter-spacing: 10px;
				line-height: 70px;
				text-align: left;
			}
		}

		// 下拉选项
		.select_box {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 5px solid #00a0e9;
			margin-bottom: 60px;
			padding-bottom: 70px;

			span {
				font-size: 70px;
				font-weight: bold;
				color: #425073;
				letter-spacing: 10px;
				line-height: 70px;
			}

			.el-icon-arrow-down {
				font-size: 56px;
				margin-top: 15px;
			}
		}

		// 下拉菜单
		.air_main {
			width: 100%;
			box-sizing: border-box;
			padding-left: 270px;

			.main {
				font-size: 60px;
				color: #afafaf;
				line-height: 60px;
				margin-bottom: 60px;
			}
		}
	}

	// 国际化
	.internat {
		width: 80%;
		margin: 0 auto;
		display: flex;
		align-content: flex-end;
		justify-content: flex-end;
		margin-bottom: 60px;

		.international {
			display: flex;
			align-items: center;
			margin-right: 10px;

			p {
				font-size: 70px;
				line-height: 70px;
				color: #9e9d9d;
				margin: 0;
				padding: 0 2px 15px 2px;
				border-bottom: 6px dotted #9e9d9d;
				margin-right: 35px;
				cursor: pointer;
			}

			// 选中状态
			.selectLang {
				color: black;
				border-color: #4d4c4c;
			}
		}

		// 购物车
		.shopping {
			width: 115px;
			height: 115px;
			cursor: pointer;
			margin-left: 30px;
		}
	}

	// 弹出内容-关注我们
	.wechat_code {
		width: 200px;
	}

	.focus {
		width: 100%;
		box-sizing: border-box;
		padding: 110px 0 30px 150px;
		background-color: #e5e5e5;

		.focus_box {
			display: flex;
			align-content: center;
			margin-bottom: 60px;

			// 标题
			.title {
				font-size: 60px;
				font-weight: bold;
				color: #6a6a6a;
				letter-spacing: 5px;
				line-height: 110px;
				border-right: 6px solid #6a6a6a;
				margin-right: 70px;
				padding-right: 70px;
			}

			// 图标组
			.icon_list {
				display: flex;
				align-content: center;

				// 图标
				img {
					width: 99px;
					height: 99px;
					margin-right: 50px;
				}

				.img_on {
					width: 139px;
					height: 79px;
					margin-top: 10px;
				}
			}
		}
	}

	/* ------------------------------ web顶部导航栏 ----------------------------- */
	.header {
		width: 100%;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px 0;
		z-index: 999;

		/* 公司LOGO */
		.icon_logo {
			width: 374px;
			height: 104px;
			margin-right: 50px;
			cursor: pointer;
		}

		// 导航操作栏
		.nav_operate {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 15px;
			box-sizing: border-box;

			// 搜索栏
			.search {
				width: 188px;
				border-bottom: 2px solid #9e9d9d;
				display: flex;
				align-items: center;

				// 输入框
				input {
					width: 100%;
					border: none;
					outline: none;
					font-size: 18px;
					font-family: "等线";
					font-weight: bolder;
					line-height: 30px;
					letter-spacing: 1px;
				}

				img {
					width: 22px;
					height: 22px;
				}
			}

			// 博客
			.blog {
				font-size: 18px;
				color: #1caaeb;
				font-weight: bolder;
				font-family: "微软雅黑";
				letter-spacing: 3px;
				padding: 0 20px;
				border-left: 1px solid rgb(83, 83, 83);
				border-right: 1px solid rgb(83, 83, 83);
				margin: 0 20px;
				cursor: pointer;
			}

			// 国际化
			.international {
				display: flex;
				align-items: center;
				margin-right: 10px;
				margin-left: 20px;

				p {
					font-size: 18px;
					line-height: 1.8;
					color: #9e9d9d;
					margin: 0;
					padding: 0 2px;
					border-bottom: 2px dotted #9e9d9d;
					margin-right: 15px;
					cursor: pointer;
				}

				// 选中状态
				.selectLang {
					color: black;
					border-color: #4d4c4c;
				}
			}

			// 购物车
			.shopping {
				width: 55px;
				height: 55px;
				cursor: pointer;
			}
		}

		// 导航栏标签
		.nav_label {
			width: 100%;

			.el-menu-demo {
				border: none;
				font-size: 18px;
			}

			// 字体样式
			.el-menu-item {
				font-size: 20px;
				font-family: "等线";
				font-weight: bold;
				color: #6c6969;
				padding: 0 5px;
				margin: 0 10px;
				letter-spacing: 2px;
			}

			// 选中状态底部横线
			.el-menu--horizontal>.el-menu-item.is-active {
				border-bottom: 1px solid #57585a;
			}

			.el-menu--horizontal>.el-menu-item {
				height: 53px;
			}
		}
	}

	.bg_color {
		border-bottom: 1px solid #aaabab;
		margin-bottom: -14px;
	}

	/* ------------------------------ NEED HELP ----------------------------- */
	.help {
		width: 125px;
		height: 175px;
		position: fixed;
		top: 30%;
		right: 0;
		z-index: 999;
		cursor: pointer;
	}

	/* ------------------------------ 顶部导航栏根据宽度适配 ----------------------------- */
	@media only screen and (max-width: 960px) {
		.web_style {
			display: none;
		}

		.header {
			box-sizing: border-box;
			padding: 80px 120px;
		}

		.header .icon_logo {
			width: 600px;
			height: 160px;
		}

		.mobile_style {
			display: block;
		}

		.wechat_code {
			width: 600px;
		}
	}

	@media only screen and (min-width: 960px) {
		.web_style {
			display: block;
		}

		.mobile_style {
			display: none;
		}
	}

	@media only screen and (min-width: 960px) {

		// ------------- pc端样式 -------------
		.website {
			font-family: "微软雅黑";

			padding-right: 20px;
			border-right: 1px solid rgb(83, 83, 83);
			cursor: pointer;
		}

		.box1 {
			display: flex;
			align-items: center;
		}

		.webBox1 {
			width: 30px;
			display: flex;
			align-items: center;

			img {
				width: 100%;
			}
		}

		.webBox {
			width: 19px;
			// margin-top: -6px;
			display: flex;
			align-items: center;
			margin-top: -3px;

			img {
				width: 100%;
			}
		}

		.webText {
			padding-left: 5px;
			font-size: 0.09375rem;
			padding-left: 8px;
			letter-spacing: 0px;
			font-weight: 600;
			color: #008000c4;
			// margin-top: 2px;
		}
	}

	@media only screen and (max-width: 960px) {
		.website {
			font-family: "微软雅黑";
			cursor: pointer;
			padding-right: 20px;
			border-right: 1px solid rgb(83, 83, 83);
		}

		.box1 {
			display: flex;
			align-items: center;
		}

		.webBox {
			width: 1.651042rem;
			margin-top: -6px;

			img {
				width: 100%;
			}
		}

		.webText {
			padding-left: 20px;
			//   color: #333;
			//   font-size: 0.09375rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue